{
  "A": {
    "long": "Actif",
    "short": "actif"
  },
  "BD": {
    "long": "Batterie",
    "short": "batterie morte"
  },
  "BES": {
    "long": "L'alimentation externe et la batterie interne sont extrêmement faibles. L'appareil va bientôt s'éteindre",
    "short": "la batterie doit être éteinte"
  },
  "BL": {
    "long": "Batterie faible",
    "short": "faible"
  },
  "BN": {
    "long": "La charge de la batterie n'est pas faible",
    "short": "d'accord"
  },
  "C": {
    "long": "Interrupteur fermé",
    "short": "fermé"
  },
  "DVS": {
    "long": "L'appareil est en veille",
    "short": "endormi"
  },
  "DVSA": {
    "long": "Mise en veille de l'appareil interrompue",
    "short": "mode veille interrompu"
  },
  "DVSQ": {
    "long": "L'appareil va bientôt se mettre en veille",
    "short": "démarrage du mode veille"
  },
  "DVSW": {
    "long": "L'appareil s'est réveillé",
    "short": "je viens de me réveiller"
  },
  "FLF": {
    "long": "Écoulement",
    "short": "écoulement"
  },
  "FLN": {
    "long": "Ne coule pas",
    "short": "ne coule pas"
  },
   "FLOV": {
    "long": "Flux rapide",
    "short": "flux rapide"
  },
  "GDSBL": {
    "long": "Localisation désactivée",
    "short": "désactivé"
  },
  "GERR": {
    "long": "Erreur de puce GPS",
    "short": "erreur"
  },
  "GLK": {
    "long": "Précision de localisation décente",
    "short": "fermé"
  },
  "GOFF": {
    "long": "Puce GPS désactivée",
    "short": "désactivé"
  },
  "GST": {
    "long": "Excellente précision de localisation",
    "short": "serrure solide"
  },
  "GULK": {
    "long": "Aucune précision de localisation",
    "short": "déverrouillé"
  },
  "HHI": {
    "long": "Haut",
    "short": "haut"
  },
  "HNO": {
    "long": "Normale",
    "short": "normale"
  },
  "HLO": {
    "long": "Faible",
    "short": "faible"
  },
  "I": {
    "long": "Inactif",
    "short": "inactif"
  },
  "MA": {
    "long": "Pas d'aimant",
    "short": "aucun aimant détecté"
  },
  "MP": {
    "long": "Aimant détecté",
    "short": "détecté"
  },
  "NC": {
    "long": "Appareil non configuré",
    "short": "non configuré"
  },
  "NONE": {
    "long": "Aucun",
    "short": "Aucun"
  },
  "NSIG": {
    "long": "L'appareil n'a pas de signal cellulaire",
    "short": "pas de signal"
  },
  "OFF": {
    "long": "Désactivé",
    "short": "désactivé"
  },
  "ON": {
    "long": "Sur",
    "short": "sur"
  },
  "PHI": {
    "long": "Haute pression",
    "short": "haut"
  },
  "PLO": {
    "long": "Basse pression",
    "short": "faible"
  },
  "POV": {
    "long": "Au dessus du seuil",
    "short": "sur"
  },
  "RE": {
    "long": "Extension pour exécuter le point de départ",
    "short": "étendre"
  },
  "RR": {
    "long": "Rétractable",
    "short": "rétracter"
  },
  "RS": {
    "long": "Arrêté",
    "short": "arrêté"
  },
  "THI": {
    "long": "Haut",
    "short": "haut"
  },
  "TNO": {
    "long": "Normale",
    "short": "normale"
  },
  "TLO": {
    "long": "Faible",
    "short": "faible"
  },
  "VFDOF": {
    "long": "VFD désactivé",
    "short": "Désactivé"
  },
  "VFDOV": {
    "long": "Vitesse supérieure à la vitesse maximale",
    "short": "Au dessus du max"
  },
  "VFDPIDT": {
    "long": "Point de consigne de suivi",
    "short": "Suivi"
  },
  "VFDRP": {
    "long": "Rampe VFD",
    "short": "Rampe"
  },
  "VFDST": {
    "long": "VFD activé",
    "short": "Sur"
  },
  "VFDUN": {
    "long": "Sous la vitesse minimale",
    "short": "Sous Min"
  },
  "WF": {
    "long": "Bouger vite",
    "short": "rapide"
  },
  "WL": {
    "long": "Bouger lentement",
    "short": "lent"
  },
  "WS": {
    "long": "Arrêté",
    "short": "arrêté"
  },
  "WUNK": {
    "long": "Inconnu",
    "short": "Inconnu"
  }
}
